module.exports = __webpack_public_path__ + "img/1x.3b0126b.jpg";